import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
    chip: {
        fontWeight: 500,
        color: theme.palette.common.white
    },
    ABERTO: {backgroundColor: theme.palette.quinary.main},
    AGUARDANDO: {
        backgroundColor: theme.palette.senary.main,
        color: theme.palette.text.primary
    },
    ENCERRADO: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.primary
    },
    SEM_PERIODO: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.text.secondary
    }
}));

/* Situação do processo de seleção pelas datas como etiqueta colorida (mesmo padrão do StatusSituacaoInscricao). */
export default function StatusProcessoSelecao({situacao}) {
    const classes = useStyles();

    if (!situacao) {
        return null;
    }

    return <Chip size='small' label={situacao.descricao} className={clsx(classes.chip, classes[situacao.codigo])}/>;
}

StatusProcessoSelecao.propTypes = {
    /* Situação calculada no back: {codigo: 'ABERTO'|'AGUARDANDO'|'ENCERRADO'|'SEM_PERIODO', descricao}. */
    situacao: PropTypes.shape({
        codigo: PropTypes.string,
        descricao: PropTypes.string
    })
};
